import DiarioOficialCard from "@adoo-ui/Molecule/DiarioOficialCard";
import NavegacaoConteudoLoadingSkeleton from "@adoo-ui/Organism/NavegacaoConteudo/NavegacaoConteudoLoadingSkeleton";
import {routeCodes} from "@constants/routes";
import {stringToSlug} from "@helpers";
import getRoute from "@helpers/getRoute";
import "./NavegacaoConteudo.scss";
import Button from "@components/ui/Atom/Button";
import React, {useEffect} from "react";
import procurarImg from "@images/PROCURAR.png";
import {NoDiariosMessage} from "../NoDiariosMessage/NoDiariosMessage";

function NavegacaoConteudo({
  filtro,
  isLoading,
  diarios,
  handleShowMore,
  showCountExecutivo,
  showCountJudiciario,
  showCountLegislativo,
  selecionarDiario,
  showCountMp,
  handleShowLess,
  handleClearFiltro,
}) {
  useEffect(() => {
    // reseta diario selecionado toda vez que navegar em /navegacao
    selecionarDiario({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtro]);

  return isLoading ? (
    <NavegacaoConteudoLoadingSkeleton />
  ) : (
    <div className="row">
      {diarios.length === 0 ? (
        <NoDiariosMessage handleClearFiltro={handleClearFiltro} />
      ) : null}
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 navegacao-conteudo-main">
        {filtro.poder === "" ||
        (filtro.poder.includes("executivo") &&
          diarios.filter((diario) => diario.poder === "executivo").length > 0) ? (
          <React.Fragment>
            <h3 style={{textAlign: "center"}}>Poder Executivo</h3>
            <div className="mt-4 do-cards-area">
              {diarios
                .filter((diario) => diario.poder === "executivo")
                .slice(0, showCountExecutivo)
                .map((diario, i) => {
                  return (
                    <DiarioOficialCard
                      key={i}
                      image={diario.caminhoArquivoAberto}
                      title={diario.nome}
                      link={getRoute(
                        routeCodes.NAVEGACAO_DETALHES,
                        diario.id,
                        diario.poder,
                        diario.esfera,
                        stringToSlug(diario.nome)
                      )}
                    />
                  );
                })}
            </div>
            <div className="button-container">
              {showCountExecutivo <
              diarios.filter((diario) => diario.poder === "executivo").length ? (
                <Button onClick={() => handleShowMore("executivo")}>Mostrar mais</Button>
              ) : null}
              {showCountExecutivo > 14 &&
              diarios.filter((diario) => diario.poder === "executivo").length > 14 ? (
                <Button onClick={() => handleShowLess("executivo")}>Mostrar menos</Button>
              ) : null}
            </div>
          </React.Fragment>
        ) : null}

        {filtro.poder === "" ||
        (filtro.poder.includes("legislativo") &&
          diarios.filter((diario) => diario.poder === "legislativo").length > 0) ? (
          <React.Fragment>
            <h3 style={{textAlign: "center"}}>Poder Legislativo</h3>
            <div className="mt-4 do-cards-area">
              {diarios
                .filter((diario) => diario.poder === "legislativo")
                .slice(0, showCountLegislativo)
                .map((diario, i) => {
                  return (
                    <DiarioOficialCard
                      key={i}
                      image={diario.caminhoArquivoAberto}
                      title={diario.nome}
                      link={getRoute(
                        routeCodes.NAVEGACAO_DETALHES,
                        diario.id,
                        diario.poder,
                        diario.esfera,
                        stringToSlug(diario.nome)
                      )}
                    />
                  );
                })}
            </div>

            <div className="button-container">
              {showCountLegislativo <
              diarios.filter((diario) => diario.poder === "legislativo").length ? (
                <Button onClick={() => handleShowMore("legislativo")}>
                  Mostrar mais
                </Button>
              ) : null}
              {showCountLegislativo > 14 &&
              diarios.filter((diario) => diario.poder === "legislativo").length > 14 ? (
                <Button onClick={() => handleShowLess("legislativo")}>
                  Mostrar menos
                </Button>
              ) : null}
            </div>
          </React.Fragment>
        ) : null}

        {filtro.poder === "" ||
        (filtro.poder.includes("judiciario") &&
          diarios.filter((diario) => diario.poder === "judiciario").length > 0) ? (
          <React.Fragment>
            <h3 style={{textAlign: "center"}}>Poder Judiciário</h3>
            <div className="mt-4 do-cards-area">
              {diarios
                .filter((diario) => diario.poder === "judiciario")
                .slice(0, showCountJudiciario)
                .map((diario, i) => {
                  return (
                    <DiarioOficialCard
                      key={i}
                      image={diario.caminhoArquivoAberto}
                      title={diario.nome}
                      link={getRoute(
                        routeCodes.NAVEGACAO_DETALHES,
                        diario.id,
                        diario.poder,
                        diario.esfera,
                        stringToSlug(diario.nome)
                      )}
                    />
                  );
                })}
            </div>
            <div className="button-container">
              {showCountJudiciario <
              diarios.filter((diario) => diario.poder === "judiciario").length ? (
                <Button onClick={() => handleShowMore("judiciario")}>Mostrar mais</Button>
              ) : null}
              {showCountJudiciario > 14 &&
              diarios.filter((diario) => diario.poder === "judiciario").length > 14 ? (
                <Button onClick={() => handleShowLess("judiciario")}>
                  Mostrar menos
                </Button>
              ) : null}
            </div>
          </React.Fragment>
        ) : null}

        {filtro.poder === "" ||
        (filtro.poder.includes("mp") &&
          diarios.filter((diario) => diario.poder === "mp").length > 0) ? (
          <React.Fragment>
            <h3 style={{textAlign: "center"}}>Ministério Público</h3>

            <div className="mt-4 do-cards-area">
              {diarios
                .filter((diario) => diario.poder === "mp")
                .slice(0, showCountMp)
                .map((diario, i) => {
                  return (
                    <DiarioOficialCard
                      key={i}
                      image={diario.caminhoArquivoAberto}
                      title={diario.nome}
                      link={getRoute(
                        routeCodes.NAVEGACAO_DETALHES,
                        diario.id,
                        diario.poder,
                        diario.esfera,
                        stringToSlug(diario.nome)
                      )}
                    />
                  );
                })}
            </div>

            <div className="button-container">
              {showCountMp < diarios.filter((diario) => diario.poder === "mp").length ? (
                <Button onClick={() => handleShowMore("mp")}>Mostrar mais</Button>
              ) : null}
              {showCountMp > 14 &&
              diarios.filter((diario) => diario.poder === "mp").length > 14 ? (
                <Button onClick={() => handleShowLess("mp")}>Mostrar menos</Button>
              ) : null}
            </div>
          </React.Fragment>
        ) : null}
      </div>
    </div>
  );
}

export default NavegacaoConteudo;
